export const environment = {
  production: false,
  apiUrl: 'https://financedashboardapi-dllcbnaela-as.a.run.app/', // Live Server
  // apiUrl: 'http://localhost:8888/janusapi/' //Localhost Testing Server
}; 